import { WebParameterContext, WebResponesContext } from '../../model/common';
import { DatePipe} from '@angular/common';
declare var app;
export class ServicesScheduleMakingForm {
    constructor() { }

    public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
        // debugger;
        let selectValue= sessionStorage.getItem("selectValue");
        console.log(selectValue,"排版类型");
        const pgId = localStorage.getItem("scheduleId");//督导给pg排班
        // debugger;
        if (webcontext.OpType == 'add'  || webcontext.OpType=='edite') {
            // alert("21212121");
            if(webcontext.OpType=="edite"){
                webcontext.SpecialParameter="updateSchedule"//修改排班时需要添加的字段
            }

            const RiQi = localStorage.getItem('scheduleDate');
            const account = JSON.parse(localStorage.getItem('account')) || {};
            let requestBody = JSON.parse(webcontext.RequestBody);
            console.log(requestBody,"值值值值值&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
            if (!requestBody['a_FK_Store_ID']) {
                webcontext.ResponseMessage.Success = false;
                webcontext.ResponseMessage.ErrorMessage = "请选择门店";
            } else if (!requestBody['a_FK_TBScheduleType_ID']) {
                webcontext.ResponseMessage.Success = false;
                webcontext.ResponseMessage.ErrorMessage = "请选择排班类型";
            } else if (!requestBody['a_SNEndDate']) {
                webcontext.ResponseMessage.Success = false;
                webcontext.ResponseMessage.ErrorMessage = "请选择结束日期";
            } else if (!requestBody['a_SNStartDate']) {
                webcontext.ResponseMessage.Success = false;
                webcontext.ResponseMessage.ErrorMessage = "请选择开始日期";
            }
            // else if (!requestBody['a_remark']) {
            //     webcontext.ResponseMessage.Success = false;
            //     webcontext.ResponseMessage.ErrorMessage = "请填写申请原因";
            // }
            //  else if (!this.compareDate(requestBody['a_SNStartDate'], requestBody['a_SNEndDate'])) {
            //     webcontext.ResponseMessage.Success = false;
            //     webcontext.ResponseMessage.ErrorMessage = "结束时间不得小于或等于开始时间";
            // } 
            else {
                let datepie:DatePipe =new DatePipe("en-US");
                let nowdate = datepie.transform(new Date(),"yyyy-MM-dd");
                requestBody['a_SNState'] = 0;
                requestBody['a_FK_SystemUser_ID'] = account.Id;
                if(pgId){
                    requestBody["a_FK_SystemUser_ID"] = pgId;
                }
                // webcontext.SpecialParameter = requestBody.a_SNStartDate + "&" + requestBody.a_SNEndDate;
                // requestBody['a_SNStartDate'] = RiQi + ' ' + requestBody['a_SNStartDate'];
                // requestBody['a_SNEndDate'] = RiQi + ' ' + requestBody['a_SNEndDate'];
                debugger;
                if(requestBody.a_SNStartDate.replace("T"," ").replace("-00:00","").length>6){
                    requestBody['a_SNStartDate'] = RiQi+" "+datepie.transform(requestBody.a_SNStartDate.replace("T"," ").replace("-00:00","").replace(/-/g,"/"),"HH:mm:ss");
                }else{
                    requestBody['a_SNStartDate'] = RiQi+" "+requestBody.a_SNStartDate+":00";
                }
                // requestBody['a_SNStartDate'] = RiQi+" "+datepie.transform(requestBody.a_SNStartDate.replace("T"," ").replace("-00:00","").replace(/-/g,"/"),"HH:mm:ss");
                if(requestBody.a_SNEndDate.replace("T"," ").replace("-00:00","").length>6){
                    requestBody['a_SNEndDate'] = RiQi+" "+datepie.transform(requestBody.a_SNEndDate.replace("T"," ").replace("-00:00","").replace(/-/g,"/"),"HH:mm:ss");
                }else{
                    requestBody['a_SNEndDate'] = RiQi+" "+requestBody.a_SNEndDate+":00";
                }
                
                if (!this.compareDate(requestBody['a_SNStartDate'], requestBody['a_SNEndDate'])) {
                    webcontext.ResponseMessage.Success = false;
                    webcontext.ResponseMessage.ErrorMessage = "结束时间不得小于或等于开始时间";
                } 
                if(selectValue== "病假" || selectValue =="年假"  || selectValue =="调休" || selectValue =="其他"){
                    if(!requestBody['a_Remark']){
                        webcontext.ResponseMessage.Success = false;
                        webcontext.ResponseMessage.ErrorMessage = "请填写申请原因";
                    
                   }
                }
                
                webcontext.RequestBody = JSON.stringify(requestBody);
                // webcontext.ResponseMessage.Success = true;
                // webcontext.ResponseMessage.ErrorMessage = "";

                
            }
        }else if(webcontext.ConfigType.toLowerCase()=="view"){
            if(typeof(webcontext.RequestBody)=="undefined"){
              webcontext.RequestBody ={};
            }
            if(webcontext.ConfigName=="UserJurisdictionStoreRelation"){
                let _id = webcontext.Account.Id;
                if(pgId){
                    _id = pgId;
                }
              webcontext.RequestBody=JSON.stringify({"a_FK_SystemUser_ID":_id});
            }
      }
    //   console.log(webcontext.RequestBody);
    //   webcontext.ResponseMessage.Success=false;
        return webcontext;
    }
    public HandleServerContextAfterDBRequest(webParameterContext: WebParameterContext, webContext: WebResponesContext): WebResponesContext {
        const that = this;
        if(webParameterContext.ConfigType.toLowerCase()=="form"){
         if(webContext.ResponseMessage.Success){
            let datepie:DatePipe =new DatePipe("en-US");
            const pgId = localStorage.getItem("scheduleId");//督导给pg排班
            let _url = "/tabs/contact/ScheduleMaking/type/";
            if(pgId){
                _url = "/tabs/contact/ScheduleMaking/view/"+pgId;
                localStorage.removeItem("scheduleId");
            }
              if(webContext.Other){
               webContext.Other.Success=true;
               webContext.url= _url + "&" +datepie.transform(new Date(),"yyyyMMddHHmmss");
              }else{
               webContext.Other={"Success":true,"url":_url + "&" +datepie.transform(new Date(),"yyyyMMddHHmmss")};
              }
         }
        
         // webContext.ResponseMessage.ErrorMessage="排版成功,请尽快联系上级领导审批通过后方可进入此系统";
         // webContext.ResponseMessage.Success=false;
        }
       
        return webContext;
    }
    private compareDate(begin, end) {
        const b1 = new Date(begin.replace(/-/g,"/")).getTime();
        const e1 = new Date(end.replace(/-/g,"/")).getTime();
        if (b1 >= e1) {
            return false;
        } else {
            return true;
        }
    }

}